/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ViewLineups_query$ref: FragmentReference;
declare export opaque type ViewLineups_query$fragmentType: ViewLineups_query$ref;
export type ViewLineups_query = {|
  +lineupsForLineupSet: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +totalSalary: ?number,
        +totalProjOwnership: ?number,
        +totalProjPoints: ?any,
        +isValid: ?boolean,
        +validityLevel: ?number,
        +locked: boolean,
        +players: ?$ReadOnlyArray<?{|
          +id: string,
          +lineupRosterSlot: {|
            +id: string,
            +rosterSlot: {|
              +id: string,
              +name: string,
            |},
          |},
          +player: {|
            +slatePlayer: {|
              +id: string,
              +position: ?string,
              +salary: number,
              +player: {|
                +name: string,
                +shortenedName: ?string,
                +team: ?{|
                  +abbreviation: string
                |},
              |},
              +suffix: ?string,
              +gupPercProj: ?any,
              +projPoints: ?any,
            |}
          |},
        |}>,
      |}
    |}>
  |},
  +$refType: ViewLineups_query$ref,
|};
export type ViewLineups_query$data = ViewLineups_query;
export type ViewLineups_query$key = {
  +$data?: ViewLineups_query$data,
  +$fragmentRefs: ViewLineups_query$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  "lineupsForLineupSet"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 9,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lineupSetId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ViewLineupsPaginationQuery.graphql.js')
    }
  },
  "name": "ViewLineups_query",
  "selections": [
    {
      "alias": "lineupsForLineupSet",
      "args": [
        {
          "kind": "Variable",
          "name": "lineupSetId",
          "variableName": "lineupSetId"
        }
      ],
      "concreteType": "GreenMachineLineupTypeConnection",
      "kind": "LinkedField",
      "name": "__ViewLineups_lineupsForLineupSet_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GreenMachineLineupTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GreenMachineLineupType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalSalary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalProjOwnership",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "totalProjPoints",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isValid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "validityLevel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "locked",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GreenMachineLineupPlayerType",
                  "kind": "LinkedField",
                  "name": "players",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LineupRosterSlotType",
                      "kind": "LinkedField",
                      "name": "lineupRosterSlot",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "RosterSlotType",
                          "kind": "LinkedField",
                          "name": "rosterSlot",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v2/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "GreenMachineSessionPlayerType",
                      "kind": "LinkedField",
                      "name": "player",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SlatePlayerType",
                          "kind": "LinkedField",
                          "name": "slatePlayer",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "position",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "salary",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PlayerType",
                              "kind": "LinkedField",
                              "name": "player",
                              "plural": false,
                              "selections": [
                                (v2/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "shortenedName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "TeamType",
                                  "kind": "LinkedField",
                                  "name": "team",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "abbreviation",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "suffix",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "gupPercProj",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "projPoints",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dc0b7685e54be731c1b33c1106a3d1fe';

module.exports = node;
